export * from './providers/detail.service';
export * from './model';
